/**
 * Удаляет параметры UTM из строки запроса.
 * 
 * @param query Строка запроса (может быть с `?` или без него).
 */
function removeUtmParameters( query: string ): string
{
	let normalizedQuery: string;
	let prefix: string;
	
	if ( query[0] === '?' )
	{
		normalizedQuery = query.substr( 1 );
		prefix = '?';
	}
	else
	{
		normalizedQuery = query;
		prefix = '';
	}
	
	return prefix + normalizedQuery
		.split( '&' )
		.filter(
			( item ) => (
				( item.substr( 0, 4 ) !== 'utm_' )
				&& ( item.substr( 0, 10 ) !== 'calltouch_' )
			),
		)
		.join( '&' );
}

/**
 * Module.
 */
export {
	removeUtmParameters as default,
};



// WEBPACK FOOTER //
// ./app/Routes/Choose/App/utils/removeUtmParameters.ts